/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Button, Tooltip, Icons, Table, FilterHeaderTable } from '~/components';

import { TIPO_COLUNA } from '~/modules/Helper/tipoColuna';
import { TIPO_VISAO } from '~/modules/Helper/tipo-visao';
import * as ModuloVisaoService from '~/modules/Modulos/services/moduloVisao.service';
import {
  valorEstaTruncado,
  obterValorChaveRegistro,
  montarPayloadTextoColuna,
} from '~/modules/Modulos/helpers/gridTextoCompleto.helper';
import TextoColunaCompleto, {
  ModalTextoColunaCompleto,
} from './textoColunaCompleto.component';
import Footer from './Footer.component';
import ArquivoForm from './arquivos/arquivos.form.component';

function TableDinamic({
  dataUltimaAtualizacao,
  moduloVisao,
  handleTableChange,
  configuracao,
  quantidadeRegistros,
  setQuantidadeRegistros,
  pagina,
  setPagina,
  modulo,
  visao,
  filtroExportacao,
  filtroOrdenacaoExportacao,
  filtro,
  setFiltro,
  periodicidadeSelecionada,
  periodoSelecionado,
  exercicioSelecionado,
  colunaFiltroRedirecionaVisao,
  valorFiltroRedirecionaVisao,
  tipoValorFiltroRedirecionaVisao,
  redirecionarDetalheVisaoAnalitica,
  urlVisaoAnalitica,
  urlVisaoAgrupamento,
  listaColunaOrdem,
  obterValoresChavesPeriodicidadePorLinha,
  redirecionarVisaoAnalitica,
  redirecionarRastreabilidade,
  possuiArquivoDigital,
  exibirAnexos,
  filtroPesquisaArquivosDigitais,
  exibirArquivosForm,
  setFiltroPesquisaArquivosDigitais,
  setExibirArquivosForm,
  tableKey,
  setDataFilterHeader,
  dataFilterHeader,
  obterColunaChave,
  obterColunaLink,
}) {
  const [textoCompleto, setTextoCompleto] = useState({
    aberto: false,
    titulo: '',
    texto: '',
    carregando: false,
  });

  async function abrirTextoCompleto(row, visaoColuna) {
    const valorChave = obterValorChaveRegistro(
      row,
      configuracao?.VisaoColunas
    );
    const fonteDados = visaoColuna?.FonteDados;
    if (!valorChave || !fonteDados) return;

    setTextoCompleto({
      aberto: true,
      titulo: visaoColuna?.NomeColuna || 'Texto completo',
      texto: '',
      carregando: true,
    });

    try {
      const response = await ModuloVisaoService.obterTextoColuna(
        montarPayloadTextoColuna({
          chaveModulo: modulo,
          nomeVisao: visao,
          fonteDados,
          valorChave,
          row,
          exercicio: exercicioSelecionado,
          periodicidade: periodicidadeSelecionada,
          periodo: periodoSelecionado,
        })
      );
      const dados = response?.data || {};
      setTextoCompleto({
        aberto: true,
        titulo: dados.NomeColuna || visaoColuna?.NomeColuna || 'Texto completo',
        texto: dados.Valor || '—',
        carregando: false,
      });
    } catch {
      setTextoCompleto({
        aberto: true,
        titulo: visaoColuna?.NomeColuna || 'Texto completo',
        texto: 'Não foi possível carregar o texto completo.',
        carregando: false,
      });
    }
  }

  function verificaAlinhamentoColuna(tipoValor) {
    if (tipoValor === TIPO_COLUNA.DECIMAL) {
      return 'right';
    }
    if (tipoValor === TIPO_COLUNA.LINK) {
      return 'center';
    }
    return 'left';
  }

  const BotaoLink = ({ value }) => {
    return (
      <Tooltip title={value && `${value.substr(0, 50)}...`}>
        <Button
          className="btn-link-externo"
          type="primary"
          onClick={() => window.open(value, '_blank')}
          icon={<Icons.LinkOutlined />}
          shape="circle"
          aria-label={`Abrir link externo${value ? `: ${value.substr(0, 40)}` : ''}`}
        />
      </Tooltip>
    );
  };

  const BotaoArquivoAnexo = props => {
    return (
      <Tooltip title="Anexos">
        <Button
          type="primary"
          icon={<Icons.FileOutlined />}
          shape="circle"
          onClick={() => exibirAnexos(props)}
          aria-label="Ver anexos"
        />
      </Tooltip>
    );
  };

  const BotaoRedirecionarDetalheVisaoAnalitica = ({
    valoresChavesPeriodicidade,
    value,
    exercicio,
    mes,
  }) => {
    const dadosColuna = Object.values(valoresChavesPeriodicidade)[0].valor;

    return (
      <Tooltip
        title="Visualizar Detalhes"
        placement={
          typeof dadosColuna === 'string' && dadosColuna.length > 50
            ? 'top'
            : 'right'
        }
      >
        <Button
          className="btn-chave-visao"
          type="link"
          style={{
            whiteSpace: 'none',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            textAlign: 'left',
          }}
          onClick={() => {
            redirecionarDetalheVisaoAnalitica(
              valoresChavesPeriodicidade,
              exercicio,
              mes
            );
          }}
        >
          <TextoValorString value={value} maxLength={100} />
        </Button>
      </Tooltip>
    );
  };

  const BotaoRedirecionarRastreabilidade = ({ row, visaoColuna, value }) => {
    const valoresRow = Object.values(row);
    const valorRow = valoresRow.filter(
      valor => typeof valor === 'string' && valor.length > 50
    )[0];

    return (
      <Tooltip
        title={`Visualizar "${visaoColuna.Rastreabilidade.TituloVisaoDestino}"`}
        placement={valorRow ? 'top' : 'right'}
      >
        <Button
          className="btn-chave-visao"
          type="link"
          style={{
            whiteSpace: 'none',
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'break-word',
            textAlign: 'left',
          }}
          onClick={() => {
            redirecionarRastreabilidade(row, visaoColuna.Rastreabilidade);
          }}
        >
          <TextoValorString value={value} maxLength={100} />
        </Button>
      </Tooltip>
    );
  };

  const BotaoRedirecionarVisaoAnalitica = ({ visaoColuna, value }) => {
    return (
      <Button
        className="btn-chave-visao"
        type="link"
        style={{
          whiteSpace: 'initial',
          wordBreak: 'break-word',
          textAlign: 'left',
        }}
        onClick={() => {
          redirecionarVisaoAnalitica(
            visaoColuna.FonteDados,
            value,
            visaoColuna.TipoValor
          );
        }}
      >
        <TextoValorString value={value} maxLength={100} />
      </Button>
    );
  };

  const TextoValorBoolean = ({ value }) => {
    return <span>{value === true ? 'Sim' : 'Não'}</span>;
  };

  const TextoValorString = ({ value, maxLength }) => {
    return (
      <span>
        {value?.length > maxLength
          ? `${value?.substring(0, maxLength)}...`
          : value}
      </span>
    );
  };

  const Columns = ({ row, value, visaoColuna }) => {
    const valoresChavesPeriodicidade = obterValoresChavesPeriodicidadePorLinha(
      row
    );
    if (value !== null && value !== undefined && value !== '') {
      if (
        visaoColuna.ColunaLink &&
        (urlVisaoAnalitica || urlVisaoAgrupamento) &&
        configuracao.Tipo !== TIPO_VISAO.AGRUPAMENTO &&
        (periodicidadeSelecionada || colunaFiltroRedirecionaVisao)
      ) {
        return (
          <BotaoRedirecionarDetalheVisaoAnalitica
            valoresChavesPeriodicidade={valoresChavesPeriodicidade}
            value={value}
            exercicio={row.Exercicio}
            mes={row.Mes}
          />
        );
      }

      if (visaoColuna.Chave && configuracao.Tipo === TIPO_VISAO.AGRUPAMENTO) {
        return (
          <BotaoRedirecionarVisaoAnalitica
            visaoColuna={visaoColuna}
            value={value}
          />
        );
      }

      if (
        visaoColuna.Rastreabilidade?.FonteDadosColunaLink ===
        visaoColuna.FonteDados
      ) {
        return (
          <BotaoRedirecionarRastreabilidade
            row={row}
            visaoColuna={visaoColuna}
            value={value}
          />
        );
      }

      if (visaoColuna.TipoValor === TIPO_COLUNA.LINK) {
        return <BotaoLink value={value} />;
      }

      if (visaoColuna.TipoValor === TIPO_COLUNA.BOOLEANO) {
        return <TextoValorBoolean value={value} />;
      }
    }

    if (valorEstaTruncado(row, visaoColuna)) {
      return (
        <TextoColunaCompleto
          preview={value}
          truncado
          nomeColuna={visaoColuna.NomeColuna}
          onVerCompleto={() => abrirTextoCompleto(row, visaoColuna)}
        />
      );
    }

    return <TextoValorString value={value} maxLength={100} />;
  };

  function ordenacao(visaoColuna) {
    if (visaoColuna.TipoValor === TIPO_COLUNA.LINK) return false;

    const ordenacaoItem = listaColunaOrdem?.find(
      item => item.ColunaOrdem === visaoColuna.FonteDados
    );

    const prioridade = ordenacaoItem?.Ordem ?? 9999;

    return {
      compare: () => 0,
      multiple: prioridade,
    };
  }

  function obterSortOrder(visaoColuna) {
    const ordenacaoPadrao = listaColunaOrdem?.find(
      item => item.ColunaOrdem === visaoColuna.FonteDados
    );

    if (ordenacaoPadrao) return ordenacaoPadrao.TipoOrdem;

    return null;
  }

  // Controla o estado visual do ícone de filtro (antd) via filteredValue.
  // Isso garante que, ao remover filtros via painel externo, o ícone também seja limpo.
  function obterCampoColunaBusca() {
    const colunaBusca =
      configuracao?.Tipo === TIPO_VISAO.AGRUPAMENTO
        ? obterColunaChave?.()
        : obterColunaLink?.();

    return colunaBusca?.FonteDados || null;
  }

  function obterFilteredValue(visaoColuna) {
    // Filtros por coluna (dropdown do header)
    const filtrosColuna = Array.isArray(dataFilterHeader?.Filtros)
      ? dataFilterHeader.Filtros
      : [];

    const filtroColuna = filtrosColuna.find(
      f =>
        f?.Campo === visaoColuna?.FonteDados &&
        f?.Valor !== null &&
        f?.Valor !== undefined &&
        f?.Valor !== ''
    );

    if (filtroColuna) return [String(filtroColuna.Valor)];

    // Filtro "principal" (o mesmo da coluna ColunaLink/ChaveUnicaModulo)
    const campoBusca = obterCampoColunaBusca();
    const filtroBusca =
      campoBusca &&
      visaoColuna?.FonteDados === campoBusca &&
      Array.isArray(filtro) &&
      filtro.length > 0 &&
      filtro[0]?.Campo === campoBusca &&
      filtro[0]?.Valor !== null &&
      filtro[0]?.Valor !== undefined &&
      filtro[0]?.Valor !== ''
        ? filtro[0]
        : null;

    if (filtroBusca) return [String(filtroBusca.Valor)];

    return null;
  }

  return (
    <>
      <Table
        key={tableKey}
        caption={configuracao?.Titulo || 'Tabela de dados do módulo'}
        dataSource={moduloVisao.Valores}
        rowKey={row => row.Id}
        pagination={false}
        scroll={{ x: 'max-content' }}
        onChange={handleTableChange}
        footer={() => (
          <Footer
            configuracao={configuracao}
            moduloVisao={moduloVisao}
            quantidadeRegistros={quantidadeRegistros}
            setQuantidadeRegistros={setQuantidadeRegistros}
            page={pagina}
            setPage={setPagina}
            modulo={modulo}
            visao={visao}
            filtroExportacao={filtroExportacao}
            filtroOrdenacaoExportacao={filtroOrdenacaoExportacao}
            periodicidade={periodicidadeSelecionada}
            periodo={periodoSelecionado}
            exercicio={exercicioSelecionado}
            colunaFiltroRedirecionaVisao={colunaFiltroRedirecionaVisao}
            valorFiltroRedirecionaVisao={valorFiltroRedirecionaVisao}
            tipoValorFiltroRedirecionaVisao={tipoValorFiltroRedirecionaVisao}
            dataUltimaAtualizacao={dataUltimaAtualizacao}
          />
        )}
      >
        {configuracao.VisaoColunas?.filter(
          visaoColuna => !visaoColuna?.OcultoGridPortal
        )?.map(visaoColuna => (
          <Table.Column
            key={visaoColuna?.FonteDados}
            title={visaoColuna.NomeColuna}
            dataIndex={visaoColuna?.FonteDados}
            sorter={ordenacao(visaoColuna)}
            sortDirections={['ascend', 'descend', null]}
            sortOrder={obterSortOrder(visaoColuna)}
            filteredValue={obterFilteredValue(visaoColuna)}
            filterIcon={filtered => (
              <Icons.FilterFilled
                aria-label={`Filtrar coluna ${visaoColuna.NomeColuna}`}
                style={{
                  color: filtered
                    ? 'var(--antd-wave-shadow-color, #000000)'
                    : undefined,
                }}
              />
            )}
            align={verificaAlinhamentoColuna(visaoColuna.TipoValor)}
            filterDropdown={props => (
              <FilterHeaderTable
                {...props}
                visaoColuna={visaoColuna}
                setDataFilterHeader={setDataFilterHeader}
                dataFilterHeader={dataFilterHeader}
                configuracao={configuracao}
                obterColunaChave={obterColunaChave}
                obterColunaLink={obterColunaLink}
                setFiltro={setFiltro}
                filtro={filtro}
                setPagina={setPagina}
              />
            )}
            render={(value, row) => {
              return {
                children: (
                  <Columns row={row} value={value} visaoColuna={visaoColuna} />
                ),
                props: {
                  'data-title': visaoColuna.NomeColuna,
                },
              };
            }}
          />
        ))}

        {possuiArquivoDigital && configuracao.Tipo === TIPO_VISAO.ANALITICO ? (
          <Table.Column
            title="Anexos"
            key="Anexos"
            align="center"
            fixed="right"
            width={60}
            render={props => {
              return {
                children: <BotaoArquivoAnexo {...props} />,
                props: {
                  'data-title': 'Anexos',
                },
              };
            }}
          />
        ) : (
          ''
        )}
      </Table>
      {filtroPesquisaArquivosDigitais ? (
        <ArquivoForm
          visible={exibirArquivosForm}
          onCancel={() => {
            setFiltroPesquisaArquivosDigitais([]);
            setExibirArquivosForm(false);
          }}
          filtroPesquisaArquivosDigitais={filtroPesquisaArquivosDigitais}
          chaveModulo={modulo}
        />
      ) : (
        <></>
      )}
      <ModalTextoColunaCompleto
        aberto={textoCompleto.aberto}
        titulo={textoCompleto.titulo}
        texto={textoCompleto.texto}
        carregando={textoCompleto.carregando}
        onClose={() =>
          setTextoCompleto({
            aberto: false,
            titulo: '',
            texto: '',
            carregando: false,
          })
        }
      />
    </>
  );
}

export default TableDinamic;
